import React from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import {
  Button,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from '@snapask/common-components';
import facebook from '@snapask/common-components/styles/buttonTheme/facebook.scss';
import twitter from '@snapask/common-components/styles/buttonTheme/twitter.scss';
import whatsapp from '@snapask/common-components/styles/buttonTheme/whatsapp.scss';

import styles from './SocialMedia.scss';

const TWITTER_WEB_INTENT_URL = 'https://twitter.com/intent/tweet';
const WHATSAPP_WEB_API = 'https://api.whatsapp.com/send';

function SocialMedia({ t, onClickSocialMedia, onClickFacebookShare }) {
  // I have to use '+' to join the 2 strings after interpolation
  // This is a bug in multiline concatenation logic in ES6
  // the '/' continuation literal doesn't work with variables.
  const twitterShareUrl = `${TWITTER_WEB_INTENT_URL}?text=${encodeURIComponent(
    t('account.shareContent')
  )}&url=${encodeURIComponent(t('account.shareUrl'))}`; // eslint-disable-line max-len
  const whatsappText = encodeURIComponent(
    `${t('account.shareContent')} ${t('account.shareUrl')}`
  );
  const whatsappShareUrl = `${WHATSAPP_WEB_API}?text=${whatsappText}`;

  const handleShare = url => () => {
    window.open(url, '_target', 'noopener=yes,noreferrer=yes');
    onClickSocialMedia();
  };

  return (
    <div className={styles.root}>
      {/* facebook */}
      <div className={styles.button}>
        <Button
          text={t('account.facebookCta')}
          onClick={onClickFacebookShare}
          theme={facebook}
          primary
        >
          <FacebookIcon className={styles.icon} width={18} height={24} />
        </Button>
      </div>

      {/* whatsapp */}
      <div className={styles.button}>
        <Button
          text={t('account.whatsappCta')}
          theme={whatsapp}
          primary
          onClick={handleShare(whatsappShareUrl)}
        >
          <WhatsappIcon className={styles.icon} width={18} height={24} />
        </Button>
      </div>

      {/* twitter */}
      <div className={styles.button}>
        <Button
          text={t('account.twitterCta')}
          theme={twitter}
          primary
          onClick={handleShare(twitterShareUrl)}
        >
          <TwitterIcon className={styles.icon} width={18} height={24} />
        </Button>
      </div>
    </div>
  );
}

SocialMedia.propTypes = {
  t: func.isRequired,
  onClickFacebookShare: func.isRequired,
  onClickSocialMedia: func.isRequired,
};

export default translate(['account'])(SocialMedia);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountReferral/components/SocialMedia/SocialMedia.jsx